import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssetGroup } from '@app/core/model/entities/asset-group/asset-group';
import { AssetInput } from '@app/core/model/entities/asset/asset';
import {
  AssetCreateModalComponent
} from '@app/features/main/views/assets/modals/asset-create-modal/asset-create-modal.component';

@Component({
  templateUrl: './asset-group-asset-create-modal.component.html',
  standalone: false
})
export class AssetGroupAssetCreateModalComponent extends AssetCreateModalComponent {
  private assetGroup = inject<{ assetGroup: AssetGroup }>(MAT_DIALOG_DATA).assetGroup;
  public formId = 'asset_group_asset_creation_dialog';

  /**
   * @return Asset data, pre-linked to the current Asset Group.
   */
  public getGeneratedObject(): AssetInput {
    return {
      ...this.assetInput,
      assetGroupIds: [this.assetGroup.id]
    };
  }
}
